import React, {Component} from 'react';
import {
    Modal, ModalBody, ModalHeader, ModalFooter,
    Button,
    Label, Input, Spinner
} from 'reactstrap';
import OrderService from '../../services/OrderService';
import {toast, ToastContainer} from 'react-toastify';
import cloneDeep from 'lodash/cloneDeep';
import {handleErrorMessage} from '../../services/CommonService';

export default class OrderGatewayNotesUpdateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: {},
        };
        this.orderService = new OrderService();
    }

    componentDidMount() {
        this.setState({order: cloneDeep(this.props.order)});
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.order !== nextProps.order) {
            this.setState({order: cloneDeep(nextProps.order)});
        }
    }

    handleChange(key, value) {
        let {order} = this.state;
        order[key] = value;
        this.setState({order});
    }

    updateOrderGatewayNotes(order) {
        let req = {
            ordNum: order.ordNum,
            notes: order.department,
        };

        order.isUpdatingOrderGatewayNotes = true;
        this.setState({order});

        this.orderService.updateOrderGatewayNotes(req).then(response => {
            order.department = response.data;
            order.isUpdatingOrderGatewayNotes = false;
            this.setState({order});
            this.props.handleOrderGatewayNotes(order);
            toast.success("Saved");
        }).catch(error => {
            order.isUpdatingOrderGatewayNotes = false;
            this.setState({order});
            toast.error(handleErrorMessage(error));
        });
    }

    render() {
        let {isOpen, toggle} = this.props;
        let {order} = this.state;

        return (
            <Modal isOpen={isOpen} size="md" scrollable={false} toggle={() => toggle(!isOpen)}>
                <ModalHeader toggle={() => toggle(!isOpen)}>
                    Order No. {order.ordNum}
                </ModalHeader>
                <ModalBody>
                    <div>
                        <Label>Notes</Label>
                        <Input
                            type={"textarea"}
                            name={"department"}
                            value={order.department || ""}
                            onChange={(e) => this.handleChange("department", e.target.value)}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="text-right">
                        <Button color={'primary'}
                                size='sm'
                                className={"mr-2"}
                                disabled={order.isUpdatingOrderGatewayNotes}
                                onClick={() => this.updateOrderGatewayNotes(order)}>
                            {order.isUpdatingOrderGatewayNotes
                                ? <Spinner className={"mr-2"} color={"light"} size={"sm"}/>
                                : <i className='fa fa-floppy-o mr-2'/>
                            }
                            {order.isUpdatingOrderGatewayNotes
                                ? "Saving"
                                : "Save"
                            }
                        </Button>
                        <Button color={"secondary"} size="sm" onClick={() => toggle(!isOpen)}>
                            <i className='fa fa-times mr-2'/>Close</Button>
                    </div>
                </ModalFooter>
                <ToastContainer/>
            </Modal>
        )
    }
}
